module.exports = __webpack_public_path__ + "asset/image/nookaLogoIcon-9054.svg";